import { render } from "./Cabang.vue?vue&type=template&id=01342ed8&scoped=true"
import script from "./Cabang.vue?vue&type=script&lang=js"
export * from "./Cabang.vue?vue&type=script&lang=js"

import "./Cabang.vue?vue&type=style&index=0&id=01342ed8&lang=scss&scoped=true"

import exportComponent from "/var/www/development/hai-parahita-dev.aksamedia.co.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01342ed8"]])

export default __exports__